import { ButtonV2 } from "../../Atoms/ButtonV2";
import { useInicioTemplate } from "./useInicioTemplate";
import { Container } from "../../Atoms/Container";
import { LayoutTemplate } from "../LayoutTemplate";
import * as S from "./styles";

export const InicioTemplate = () => {
  const { primeiroNome, handleMeusAgendamentos, handleNovoAgendamento } =
    useInicioTemplate();
  const Project = process.env.REACT_APP_PROJECT;

  return (
    <LayoutTemplate>
      <Container>
        <div className="mx-auto w-full max-w-6xl">
          <div className="border border-solid border-[#E1E7E4] rounded-[100px] w-fit flex py-[5px] px-[10px] gap-[10px] mb-8">
            <img src="/assets/svgs/icon-star-blue.svg" alt="icone estrela" />
            <p className="text-[10px]">BEM-VINDO</p>
          </div>
          <div className="mb-12">
            <h1 className="text-4xl mb-2 md:text-[56px] font-bold md:mb-8">
              Olá, {primeiroNome}
            </h1>
            <h2 className="text-2xl md:text-[52px] font-semibold text-[#4D514F]">
              O que vamos fazer hoje?
            </h2>
          </div>

          <div className="flex gap-4 flex-wrap">
            <S.MeusAgendamentos className="rounded-[10px] w-full max-w-md py-8 px-8"
              data-project-starcheck={Project === "starcheck"}
              data-project-log={Project === "log"}
              data-project-vlx={Project === "vlx"}
              data-project-tokyo={Project === "tokyo"}>
              <img
                src="/assets/svgs/icon-calendar-search.svg"
                alt="icone calendario"
                className="mb-20"
              />

              <div className="mb-5">
                <h3 className="text-2xl text-white font-extrabold mb-2">
                  Meus agendamentos
                </h3>
                <p className="text-sm text-white">
                  Acompanhe vistorias agendadas, veja histórico e reagende
                  quando precisar
                </p>
              </div>

              <button
                onClick={handleMeusAgendamentos}
                className="flex gap-3 items-center text-white py-4"
              >
                Acessar
                <img
                  alt="seta para a direira"
                  src="/assets/svgs/icon-arrow-forward.svg"
                />
              </button>
            </S.MeusAgendamentos>
            <S.NovoAgendamento className="rounded-[10px] w-full max-w-[632px] py-8 px-8"
              data-project-starcheck={Project === "starcheck"}
              data-project-log={Project === "log"}
              data-project-vlx={Project === "vlx"}
              data-project-tokyo={Project === "tokyo"}>
              <img
                src="/assets/svgs/icon-add.svg"
                alt="icone calendario"
                className="mb-20"
              />

              <div className="mb-5">
                <h3 className="text-2xl font-extrabold mb-2">
                  Novo agendamento
                </h3>
                <p className="text-sm">
                  Agende a sua vistoria. Transferência, primeiro emplacamento ou
                  primeiro registro. Pagamento online, sem fila.
                </p>
              </div>

              <ButtonV2
                onClick={handleNovoAgendamento}
                className="bg-[#20332F] text-white"
              >
                Acessar
                <img
                  alt="seta para a direira"
                  src="/assets/svgs/icon-arrow-forward.svg"
                />
              </ButtonV2>
            </S.NovoAgendamento>
          </div>
        </div>
      </Container >
    </LayoutTemplate >
  );
};
